import { moduleProviderFactory } from 'core/providers';
import { FacilityList, FacilityEdit, FacilityPreview, FacilitySchedule, FacilityCreate, FacilityHistoryList } from 'application/facility/pages';

(function () {
    moduleProviderFactory.application.register({
        routes: [
            {
                name: 'master.app.main.facility',
                pattern: '/facilities',
                children: [
                    {
                        name: 'master.app.main.facility.list',
                        pattern: '',
                        component: FacilityList,
                        tabTitle: 'FACILITY.LIST.TITLE',
                        data: {
                            title: 'FACILITY.LIST.TITLE'
                        }
                    },
                    {
                        name: 'master.app.main.facility.edit',
                        pattern: '/edit/:id',
                        tabTitle: 'Edit Facility',
                        component: FacilityEdit,
                        authorization: 'portalSection.update',
                        data: {
                            title: 'FACILITY.EDIT.TITLE'
                        },
                    },
                    {
                        name: 'master.app.main.facility.preview',
                        pattern: '/preview/:id',
                        tabTitle: 'FACILITY.PREVIEW.TITLE',
                        component: FacilityPreview,
                        data: {
                            title: 'FACILITY.PREVIEW.TITLE'
                        },
                    },
                    {
                        name: 'master.app.main.facility.schedule',
                        pattern: '/schedule/:id',
                        tabTitle: 'FACILITY.SCHEDULE.TITLE',
                        component: FacilitySchedule,
                        data: {
                            title: 'FACILITY.SCHEDULE.TITLE',
                            crumbs: {
                                title: 'Schedule',
                                route: 'master.app.main.facility.schedule'
                            } 
                        },
                    },
                    {
                        name: 'master.app.main.facility.create',
                        pattern: '/upload',
                        tabTitle: 'Upload Facilities',
                        component: FacilityCreate,
                        data: {
                            title: 'FACILITY.LIST.TITLE'
                        }
                    },
                    {
						name: "master.app.main.facility.facility-history.list",
						pattern: '/history',
                        tabTitle: 'FACILITY_HISTORY.LIST.TITLE',
						authorization: "portalSection.read",
						component: FacilityHistoryList,
						data: {
							back: "master.app.main.facility.list",
							title: "FACILITY_HISTORY.LIST.TITLE",
						},
					},           
                ]
            }
        ],
        menu: [
            {
                title: 'MENU.FACILITIES',
                icon:  'facilities',
                order: 4,
                subMenu: [
                    {
                        title: 'MENU.FACILITIES',
                        route: 'master.app.main.facility.list',
                        order: 1,
                    }
                ]
            }
        ]
    });
})();

